import React, { createContext, ReactElement, useState } from 'react';

interface SortToggleContextType {
  defaultSort: SortConfig | undefined;
  setDefaultSort: (sortConfig: SortConfig | undefined) => void;
}

const SortToggleContext = createContext<SortToggleContextType>({
  defaultSort: undefined,
  setDefaultSort: () => {},
});

const SortToggleProvider = ({
  children,
}: {
  children: ReactElement | ReactElement[];
}) => {
  const [defaultSort, setDefaultSort] = useState<SortConfig>();

  return (
    <SortToggleContext.Provider
      value={{
        defaultSort,
        setDefaultSort,
      }}
    >
      {children}
    </SortToggleContext.Provider>
  );
};

export { SortToggleContext, SortToggleProvider };
